(function () {
  'use strict';

  function init() {
    var input = document.getElementById('pblog-search-input');
    var resultsEl = document.getElementById('pblog-search-results');
    var dataEl = document.getElementById('pblog-search-data');
    if (!input || !resultsEl || !dataEl) return;

    var data = [];
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      data = [];
    }

    function render(matches, query) {
      resultsEl.innerHTML = '';

      if (query.trim() === '') {
        resultsEl.hidden = true;
        return;
      }

      if (matches.length === 0) {
        var empty = document.createElement('li');
        empty.className = 'pblog__search-empty';
        empty.textContent = 'No matching press coverage.';
        resultsEl.appendChild(empty);
        resultsEl.hidden = false;
        return;
      }

      matches.slice(0, 8).forEach(function (item) {
        var li = document.createElement('li');
        li.className = 'pblog__search-item';

        var a = document.createElement('a');
        a.href = item.url;

        var title = document.createElement('span');
        title.className = 'pblog__search-item-title';
        title.textContent = item.title;

        a.appendChild(title);

        if (item.tag) {
          var tag = document.createElement('span');
          tag.className = 'pblog__search-item-tag';
          tag.textContent = item.tag;
          a.appendChild(tag);
        }

        li.appendChild(a);
        resultsEl.appendChild(li);
      });

      resultsEl.hidden = false;
    }

    function search(query) {
      var q = query.trim().toLowerCase();
      if (q === '') return [];
      return data.filter(function (item) {
        return (
          (item.title && item.title.toLowerCase().indexOf(q) !== -1) ||
          (item.excerpt && item.excerpt.toLowerCase().indexOf(q) !== -1) ||
          (item.tag && item.tag.toLowerCase().indexOf(q) !== -1)
        );
      });
    }

    var debounceTimer;
    input.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      var value = input.value;
      debounceTimer = setTimeout(function () {
        render(search(value), value);
      }, 120);
    });

    input.addEventListener('keydown', function (e) {
  if (e.key === 'Enter') {
    e.preventDefault();
    var matches = search(input.value);
    if (matches.length > 0) {
      window.location.href = matches[0].url;
    }
  }
});

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.pblog__search-wrap')) {
        resultsEl.hidden = true;
      }
    });

    input.addEventListener('focus', function () {
      if (input.value.trim() !== '') {
        render(search(input.value), input.value);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();